import { injectable, inject } from "inversify";
import { Service } from "@catalogue/domain/models/service.model";
import { CatalogueRepository } from "@catalogue/data/repositories/catalogue.repository";
import { Pagination } from "@core/domain/models/pagination";

@injectable()
export class GetAllServicesUseCase {
    constructor(
        @inject(CatalogueRepository)
        private readonly catalogueRepository: CatalogueRepository
    ) { }

    async execute(
        filters?: { name?: string; entityId?: number },
        pagination?: Pagination
    ): Promise<{ items: Service[]; total: number }> {
        const services = await this.catalogueRepository.getAllServices(filters, pagination);

        // Count is set to the length of the array for now
        // Later it can be updated to use the actual count from the API
        return {
            items: services,
            total: services.length
        };
    }
}